import styled from 'styled-components';

export const Root = styled.div`
  ${(props) =>
    props.clickable &&
    `
      &:hover {
        cursor: pointer;
      }
  `}
`;

export const Image = styled.img`
  display: block;
  max-width: 120px;
  max-height: 86px;
  border-radius: 4px;
`;

export const TextWrapper = styled.div`
  word-break: break-word;
`;

export const FlexibleContracts = styled.div`
  background-color: #f6f7ff;
  padding: 32px;
  border-radius: 16px;
`;
